export const navMenu = [
  {
    list: "Home",
    route: "/",
    subMenuList: [],
  },
  {
    list: " About",
    route: "/about",
    subMenuList: [
      { list: "Award", route: "#url" },
      { list: "Mission", route: "#url" },
      { list: "Vision", route: "#url" },
    ],
  },
  {
    list: "Service",
    route: "/service",
    subMenuList: [
      { list: " UI/UX", route: "#url" },
      { list: "Frontend Backend", route: "#url" },
      { list: "Digital Marketing SEO", route: "#url" },
    ],
  },
  {
    list: "Career",
    route: "/career",
    subMenuList: [
      { list: "Job", route: "#url" },
      { list: "Internship", route: "#url" },
      { list: "Industrial Training", route: "#url" },
    ],
  },
  {
    list: "Solutions",
    route: "/solutions",
    subMenuList: [],
  },
  {
    list: "Projects",
    route: "#url",
    subMenuList: [],
  },
];
